// Async Thunk for SignIn
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as CognitoService from "../service/cognito";
import {  userSignInAttrs } from "../interfaces/interface";


export const signInAction = createAsyncThunk(
  "auth/signIn",

  async (userInput: userSignInAttrs) => {
    const response = await CognitoService.signIn(userInput.email,userInput.password);
    return JSON.parse(JSON.stringify(response));
  },
);
